import { render } from "./ConfiguracionMFA.vue?vue&type=template&id=0dccb22a&scoped=true"
import script from "./ConfiguracionMFA.vue?vue&type=script&lang=js"
export * from "./ConfiguracionMFA.vue?vue&type=script&lang=js"

import "./ConfiguracionMFA.vue?vue&type=style&index=0&id=0dccb22a&scoped=true&lang=css"
import "@/assets/css/listaRegistros.css?vue&type=style&index=1&id=0dccb22a&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dccb22a"]])

export default __exports__